import { z } from "zod";

/** Origin of an event timestamp; null is reserved for legacy rows with unknown provenance. */
export const EventTimeSourceSchema = z.enum([
  "SERVER_RECORDED",
  "PHONE_REPORTED",
  "MANAGER_REPORTED",
]);

export type EventTimeSource = z.infer<typeof EventTimeSourceSchema>;
